import React from 'react';
import { formatPrice, getItemsSubtotal } from '../../utils/orderUtils';
import './OrderItemsDetail.css';

const OrderItemsDetail = ({ items = [], shippingService, shippingCost, total }) => {
  const subtotal = getItemsSubtotal(items);

  return (
    <div className="order-items-detail">
      <div className="order-items-header">
        <span>Produto</span>
        <span>Qtd</span>
        <span>Unit.</span>
        <span>Total</span>
      </div>

      {items.length === 0 ? (
        <p className="order-items-empty">Itens não disponíveis</p>
      ) : (
        items.map((item, i) => (
          <div key={i} className="order-items-row">
            <div className="order-items-product">
              <span className="order-items-name">{item.name}</span>
              {item.size && <span className="order-items-size">Tam. {item.size}</span>}
            </div>
            <span className="order-items-qty">{item.quantity || 1}</span>
            <span className="order-items-unit">{formatPrice(item.price)}</span>
            <span className="order-items-line-total">
              {formatPrice((item.price || 0) * (item.quantity || 1))}
            </span>
          </div>
        ))
      )}

      <div className="order-items-totals">
        {items.length > 0 && (
          <div className="order-items-totals-row">
            <span>Subtotal</span>
            <span>{formatPrice(subtotal)}</span>
          </div>
        )}
        {shippingService && (
          <div className="order-items-totals-row order-items-totals-row--shipping">
            <span>Frete — {shippingService}</span>
            <span>{formatPrice(shippingCost)}</span>
          </div>
        )}
        <div className="order-items-totals-row order-items-totals-row--grand">
          <span>Total pago</span>
          <span>{formatPrice(total)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsDetail;
